import { render, staticRenderFns } from "./ImageBrowser.vue?vue&type=template&id=712c8a62&"
import script from "./ImageBrowser.vue?vue&type=script&lang=js&"
export * from "./ImageBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports